module.exports = __webpack_public_path__ + "img/chromecast_video_art_small.2468c10.png";